import 'ui-core/widgets/publication-content/js/publication-content';

var initiator = {
    leftElement: '.custom__journal__left',
    rightElement: '.custom__journal__right',

    init: function () {
        initiator.checkEmpty();
    },

    checkEmpty: function () {
        if ($(initiator.rightElement).children().length === 0) {
            $(initiator.leftElement).removeClass('col-sm-8 col-md-8');
            $(initiator.leftElement).addClass('col-sm-12 col-md-12');
            $(initiator.rightElement).removeClass('col-sm-4');
            $(initiator.rightElement).hide();
        }
    },
};

UX.initiator = initiator; // add to global namespace

if ($('.custom__journal').length) {
    UX.initiator.init();
}
